// Pagination.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import './Paginationhref.css';

export const Pagination2 = ({ totalItems, itemsPerPage, basePath, curPage }) => {
  const pageCount = Math.ceil(totalItems / itemsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, i) => i + 1);

  const generateHref2 = (pageNumber) => {
    return `${basePath}&page=${pageNumber}`;
  };
  const generateHref = (newPage) => {
    // Create a URL object from the provided URL string
    const url = new URL(basePath);
    
    // Update the 'page' query parameter
    url.searchParams.set('page', newPage);
  
    // Return the new URL as a string
    return url.toString();
  };

  return (
    <nav className="pagination">
      <ul>
        <li className={`page-item ${curPage === 1 ? 'disabled' : ''}`}>
          <a href={curPage > 1 ? generateHref(curPage - 1) : '#'} aria-disabled={curPage === 1}>
            &lt;
          </a>
        </li>

        {pageNumbers.map(number => (
          <li key={number} className={`page-item ${number === curPage ? 'active' : ''}`}>
            <a href={generateHref(number)}>
              {number}
            </a>
          </li>
        ))}

        <li className={`page-item ${curPage === pageCount ? 'disabled' : ''}`}>
          <a href={curPage < pageCount ? generateHref(curPage + 1) : '#'} aria-disabled={curPage === pageCount}>
            &gt;
          </a>
        </li>
      </ul>
    </nav>
  );
};


export const generateCanonicalLink = ({basePath, curpage}) => {
  const generateHref = (newPage) => {
    const url = new URL(basePath);
    url.searchParams.set('page', newPage);
    return url.toString();
  };

  const canonicalUrl = generateHref(curpage);

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};


export const Pagination = ({ totalItems, itemsPerPage, basePath, curPage }) => {
  const pageCount = Math.ceil(totalItems / itemsPerPage);
  const maxVisible = 5; // max number of center pages
  const pageNumbers = [];

  const generateHref = (newPage) => {
    const url = new URL(basePath, window.location.origin);
    url.searchParams.set('page', newPage);
    return url.toString();
  };

  const addPage = (number) => {
    pageNumbers.push(
      <li key={number} className={`page-item ${number === curPage ? 'active' : ''}`}>
        <a href={generateHref(number)}>{number}</a>
      </li>
    );
  };

  // Always show first page
  addPage(1);

  if (curPage > 4) {
    pageNumbers.push(<li key="start-ellipsis" className="page-ellipsis">…</li>);
  }

  const startPage = Math.max(2, curPage - 1);
  const endPage = Math.min(pageCount - 1, curPage + 1);

  for (let i = startPage; i <= endPage; i++) {
    addPage(i);
  }

  if (curPage < pageCount - 3) {
    pageNumbers.push(<li key="end-ellipsis" className="page-ellipsis">…</li>);
  }

  if (pageCount > 1) {
    addPage(pageCount);
  }

  return (
    <nav className="pagination-bar">
      <ul>
        <li className={`page-item ${curPage === 1 ? 'disabled' : ''}`}>
          <a href={curPage > 1 ? generateHref(curPage - 1) : '#'}>&lt; Previous</a>
        </li>

        {pageNumbers}

        <li className={`page-item ${curPage === pageCount ? 'disabled' : ''}`}>
          <a href={curPage < pageCount ? generateHref(curPage + 1) : '#'}>Next &gt;</a>
        </li>
      </ul>
    </nav>
  );
};